import React from 'react';
import { string, func, array, bool } from 'prop-types';
import styled from 'styled-components';
import { map, get, size, upperCase, replace } from 'lodash';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import { Row, SalesChannelSelect, FormInput, FormSelect, Button } from '../../common';
import { Query } from '../../graphql';
import GET_CATEGORIES from '../../../queries/GET_CATEGORIES';

const SpaceBetween = styled.div`
    width: ${({ width }) => width};
`;

const Filters = ({
    currentValue,
    categoryOption,
    onChangeCategories,
    onChangeSalesChannel,
    hall,
    onChangeHall,
    onClickSearch,
    searchDisabled,
    uniqueSalesChannel
}) => {
    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';
    const formatCategoryOptions = (data) => map(get(data, 'getCategories.data', []), ({ categoryId: value, name: label }) => {
        return {
            label: `${value} - ${label}`,
            value
        };
    });
    return (
        <FlexContainer padding={23}>
            <Row
                border='1px solid #eaeaea'
                borderRadius={3}
                padding='3px 13px'
                noWrap={!fullWidth}
            >
                <SalesChannelSelect
                    disabled={uniqueSalesChannel}
                    allSelected={uniqueSalesChannel}
                    native
                    label='Locales'
                    optionValueProp='store'
                    onChange={({ value }) => !uniqueSalesChannel && onChangeSalesChannel(get(value, 'value', null))}
                />
                <SpaceBetween width={spaceBetweenWidth} />
                <FormInput
                    label='Pasillos'
                    placeholder='Ingresar pasillo'
                    noSpecialCharacters
                    noSpaces
                    maxLength={3}
                    value={replace(upperCase(hall || ''), ' ', '')}
                    onChange={event => {
                        const value = get(event, 'target.value');
                        onChangeHall((size(value) && value) || null);
                    }}
                />
                <SpaceBetween width={spaceBetweenWidth} />
                <Query
                    query={GET_CATEGORIES}
                    variables={{ action: 'categories' }}
                >
                    {({ data }) => {
                        const options = formatCategoryOptions(data);
                        return (
                            <FormSelect
                                label='Categorías'
                                options={options}
                                onChange={({ value }) => onChangeCategories(value)}
                                value={categoryOption}
                            />
                        );
                    }}
                </Query>
                <SpaceBetween width={spaceBetweenWidth} />
                <FlexContainer
                    width={fullWidth && '100%'}
                    align='flex-end'
                    mB={10}
                >
                    <Button
                        text='Buscar'
                        disabled={searchDisabled}
                        onClick={() => onClickSearch()}
                    />
                </FlexContainer>
            </Row>
        </FlexContainer>
    );
};

Filters.propTypes = {
    currentValue: string,
    categoryOption: array,
    onChangeCategories: func,
    onChangeSalesChannel: func,
    searchDisabled: bool,
    onChangeHall: func,
    onClickSearch: func,
    hall: string,
    uniqueSalesChannel: bool
};

Filters.defaultProps = {
    currentValue: '100%',
    categoryOption: [],
    onChangeCategories: () => {},
    onChangeSalesChannel: () => {},
    onChangeHall: () => {},
    onClickSearch: () => {},
    searchDisabled: true,
    hall: null,
    uniqueSalesChannel: false
};

export default Filters;
